<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="ClassSetForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Class Set</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="setName"
                  label="Set Name"
                  :rules="[formRules.required]"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :disabled="action == 'Update'"
                  :color="$vuetify.theme.themes.light.inputColor"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="program_id"
                  :rules="[formRules.required]"
                  :items="programsList"
                  item-value="id"
                  item-title="name"
                  label="Please Select Program"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :disabled="action == 'Update'"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="batch_selected"
                  :disabled="action == 'Update'"
                  @update:modelValue="showAddBatch"
                  :rules="[formRules.required]"
                  :items="batchList"
                  item-value="id"
                  :item-title="
                    (item) =>
                      item.year != ''
                        ? `${item.name}  (${item.year})`
                        : `${item.name}`
                  "
                  label="Please Select Batch"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="action == 'Add'">
                <v-file-input
                  @change="parseCSV()"
                  clearable
                  label="Upload Student List"
                  accept=".csv"
                  variant="outlined"
                  density="compact"
                  v-model="csv_file"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-card class="my-5 dt-container" elevation="0" outlined>
              <div class="text-h4" v-if="!parsed && csv_file">Loading...</div>
              <v-data-table
                v-if="parsed && fetched_data.length > 0"
                :headers="action == 'Add' ? headers : headers1"
                :items="fetched_data"
                :loading="loading"
                hover
                :items-per-page="-1"
                density="compact"
                class="rounded-lg"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
                <template v-slot:[`item.canBeAdded`]="{ item }">
                  <v-chip
                    size="x-small"
                    :color="
                      item.studentExist
                        ? item.canBeAdded
                          ? 'green'
                          : 'red'
                        : 'warning'
                    "
                    >{{
                      item.studentExist
                        ? item.canBeAdded
                          ? "OK"
                          : "Already added from other set"
                        : "Student Not Found"
                    }}</v-chip
                  >
                </template>
                <template v-slot:[`item.actions`]="{ item, index }">
                  <v-btn
                    color="red"
                    class="white--text"
                    size="x-small"
                    @click="remove(item, index)"
                    rounded
                  >
                    remove
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <SkillAssessmentBatchDialog
      :data="batch_group"
      :action="'Add'"
      :batchToAdd="2"
    />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Warning</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to remove this student in the list?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="proceedDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import Papa from "papaparse";
import SkillAssessmentBatchDialog from "./SkillAssessment/SkillAssessmentBatchDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialogConfirmDelete: false,
      dialog: false,
      itemToDelete: null,
      indexToDelete: null,
      exceldata: [],
      program_id: null,
      email: null,
      address: null,
      batch_selected: null,
      batch: null,
      batch_year: null,
      batch_group: null,
      batchList: [],
      program_tied_id: null,
      setName: null,
      btnLoading: false,
      loading: false,
      csv_results: [],
      csv_file: null,
      parsed: false,
      headers: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        { title: "Status", value: "canBeAdded", align: "center" },

        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      headers1: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        {
          title: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: 200,
        },
      ],
      programsList: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      fetched_data: [],
      removedStudent: [],
    };
  },
  components: {
    SkillAssessmentBatchDialog,
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.removedStudent = [];
        // console.log(data);
        if (data.id) {
          // console.log("asdas", data);
          this.setName = data.name;
          this.program_id = data.program_id;
          this.batch_selected = data.student_batch_id.toString();
          this.loadClasslist();
        } else {
          this.fetched_data = [];
          this.setName = null;
          this.program_id = null;
          this.batch_selected = null;
          this.csv_file = null;
        }

        this.$refs.ClassSetForm.resetValidation();
      },
      deep: true,
    },
    parsed: {
      handler(data) {
        if (data) {
          this.fetchStudents();
        }
      },
    },
    batch_selected: {
      handler(data) {
        if (data) {
          this.fetchStudents();
        }
      },
    },

    program_id: {
      handler(data) {
        if (data) {
          this.fetchStudents();
        }
      },
    },
  },
  computed: {
    // getProgramName() {
    //   let name = "";
    //   for (let i = 0; i < this.programsList.length; i++) {
    //     if (this.programsList[i].id == this.$store.state.user.program_id)
    //       name = this.programsList[i].name;
    //   }
    //   return name;
    // },
  },

  mounted() {
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      console.log("vcalled me");
      this.getBatchList();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentBatchDialog");
  },
  methods: {
    initialize() {
      this.getBatchList();
      this.getPrograms();
    },

    fetchStudents() {
      console.log("FETCHING .....");

      if (this.batch_selected && this.program_id && this.csv_results.data) {
        let data = {
          students: JSON.stringify(this.csv_results.data),
          batch_id: this.batch_selected,
          program_id: this.program_id,
        };
        this.axiosCall("/student/check-students", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            // console.log(res.data);
            this.fetched_data = res.data.data;
          }
        });
      }
    },

    loadClasslist() {
      this.axiosCall("/student/getMyStudentBySet/" + this.data.id, "GET").then(
        (res) => {
          if (res) {
            console.log("classDATA", res.data);
            this.parsed = true;
            this.fetched_data = res.data;
          }
        },
      );
    },

    showAddBatch() {
      console.log("SLEE", this.batch_selected);
      if (this.batch_selected == -1) {
        this.batch_group = { id: null };
      }
    },

    parseCSV() {
      Papa.parse(this.csv_file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.csv_results = results;
          this.parsed = true;
        }.bind(this),
      });
    },

    remove(item, index) {
      this.itemToDelete = item;
      this.indexToDelete = index;
      this.dialogConfirmDelete = true;
    },

    proceedDelete() {
      this.removedStudent.push(this.itemToDelete);
      this.fetched_data.splice(this.indexToDelete, 1);
      this.dialogConfirmDelete = false;
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.message = "Removed successfully";
      this.fadeAwayMessage.header = "System Message";
      this.itemToDelete = null;
      this.indexToDelete = null;
    },

    async save() {
      let validation = await this.$refs.ClassSetForm.validate();

      if (validation.valid) {
        let checkedList = this.fetched_data.filter(
          (data) => data.studentExist == false || data.canBeAdded == false,
        );
        if (checkedList.length > 0) {
          this.btnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message =
            "Please remove student/s having status not OK";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.btnLoading = true;
          let data = {
            batch_id: this.batch_selected,
            student_list: JSON.stringify(this.fetched_data),
            set_name: this.setName,
            program_id: this.program_id,
          };
          this.axiosCall("/student/add-set", "POST", data).then((res) => {
            if (res.data.status == 201) {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = "Added successfully";
              this.fadeAwayMessage.header = "System Message";
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          });
        }
      } else {
        this.btnLoading = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.message = "Please fill in required field.";
        this.fadeAwayMessage.header = "System Message";
      }
    },

    async update() {
      let validation = await this.$refs.ClassSetForm.validate();

      if (validation.valid) {
        this.btnLoading = true;
        let data = {
          batch_id: this.batch_selected,
          student_list: JSON.stringify(this.fetched_data),
          set_name: this.setName,
          program_id: this.program_id,
          removedStudent: JSON.stringify(this.removedStudent),
          group_list_id: this.data.id,
        };
        this.axiosCall("/student/update-set", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeClassSetDialog", true);
      this.dialog = false;
    },

    getBatchList() {
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
      });
    },

    getPrograms() {
      this.axiosCall("/program/getProgramsByInstitute", "GET").then((res) => {
        this.programsList = res.data;
        // this.programs = this.programsList[this.programsList.length - 1].id;
      });
    },
  },
};
</script>
